import React from "react";
import Skeleton from "./Skeleton";
import ProjectCardsSkeleton from "./ProjectCardsSkeleton";
import skeletonStyles from "../../style/skeleton.module.css";

const ProjectsSectionSkeleton = () => (
  <div
    className="container page-shell pb-4 mt-4 mb-2 mb-md-0 skeleton-page"
    aria-busy="true"
    aria-live="polite"
    aria-label="Loading featured projects"
  >
    <Skeleton className={skeletonStyles.skeletonTitle} />
    <div className={`${skeletonStyles.skeletonStack} py-2`}>
      <Skeleton className={skeletonStyles.skeletonParagraph} />
      <Skeleton
        className={`${skeletonStyles.skeletonParagraph} ${skeletonStyles.skeletonParagraphShort}`}
      />
    </div>

    <ProjectCardsSkeleton count={4} />

    <Skeleton className={skeletonStyles.skeletonExploreButton} />
  </div>
);

export default ProjectsSectionSkeleton;
